import React from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';

function DateRangeDropdown({ selectedRange, handleDateRangeChange, dateRanges = [] }) {

    // If no date ranges are provided, use default ranges
    if(dateRanges.length === 0) {
        dateRanges = [
            { label: 'Last 30 days', value: '30 days' },
            { label: 'Last 60 days', value: '60 days' },
            { label: 'Last 90 days', value: '90 days' },
            { label: 'Last 6 months', value: '6 months' },
            { label: 'Last 12 months', value: '12 months' }
        ];
    }

    return (      

    <Dropdown onSelect={handleDateRangeChange}>
        <Dropdown.Toggle variant="secondary" className="navbar-drop-buttons" id="dropdown-basic">
            {selectedRange || 'Select Date Range'}
        </Dropdown.Toggle>
        <Dropdown.Menu className="el-admin">
            {dateRanges && (
                <>
                {dateRanges.map((range) => (
                    <Dropdown.Item key={range.value} eventKey={range.value}>
                        {range.label}
                    </Dropdown.Item>
                ))}
                </>
            )}
        </Dropdown.Menu>
    </Dropdown>

    );
}

export default DateRangeDropdown;
